/**
 * Возвращает CSS opacity (0-1) в зависимости от разницы дат.
 * - 0-3 мин: 0-20% непрозрачности
 * - 3-10 мин: 20-60% непрозрачности
 * - >10 мин: 70% непрозрачности
 * @param {string|Date} currentDate - Текущая дата.
 * @param {string|Date} nearbyDate - Сравниваемая дата.
 * @returns {number} Значение opacity от 0 до 1.
 */
export function getCSSOpacityByDates(currentDate, nearbyDate) {
  if (!currentDate || !nearbyDate) return 1;

  const tA = new Date(currentDate).getTime();
  const t = new Date(nearbyDate).getTime();

  if (Number.isNaN(tA) || Number.isNaN(t)) return 1;

  const diffSec = Math.max(0, Math.abs(tA - t) / 1000); // разница в секундах

  // 70% для diffSec > 10 мин
  let opacity = 70;

  // <= 3 мин (180 сек): 0% -> 20%
  if (diffSec <= 180) {
    opacity = (diffSec / 180) * 20;
  }

  // <= 10 мин (600 сек): 20% -> 60%
  if (diffSec <= 600) {
    opacity = 20 + ((diffSec - 180) / (600 - 180)) * (60 - 20);
  }

  // переводим значение в корректное для css
  return (100 - opacity) / 100;
}

export default getCSSOpacityByDates;
